import React from 'react';

export enum ContainerVariant {
  Default = 'default',
  Centered = 'centered',
  Fullscreen = 'fullscreen',
  Card = 'card',
  Form = 'form',
}

export enum ContainerSize {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
  Full = 'full',
}

export enum ContainerPadding {
  None = 'none',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
}

interface ContainerProps {
  children: React.ReactNode;
  variant?: ContainerVariant;
  size?: ContainerSize;
  padding?: ContainerPadding;
  className?: string;
  background?: string;
  centerVertical?: boolean;
  centerHorizontal?: boolean;
  style?: React.CSSProperties;
}

const sizeClasses = {
  sm: 'max-w-sm',
  md: 'max-w-xl',
  lg: 'max-w-xl',
  xl: 'max-w-xl',
  full: 'w-full',
};

const paddingClasses = {
  none: '',
  sm: 'p-4',
  md: 'p-8 md:p-12',
  lg: 'p-12 md:p-16',
  xl: 'p-16 md:p-20',
};

const variantClasses = {
  default: 'w-full',
  centered: 'mx-auto',
  fullscreen: 'min-h-screen',
  card: 'rounded-lg shadow-sm border border-gray-200',
  form: 'min-h-screen flex flex-col justify-center',
};

export const Container: React.FC<ContainerProps> = ({
  children,
  variant = ContainerVariant.Default,
  size = ContainerSize.Full,
  padding = ContainerPadding.None,
  className = '',
  background = 'bg-white',
  centerVertical = false,
  centerHorizontal = false,
  style,
}) => {
  const baseClasses = [
    variantClasses[variant],
    sizeClasses[size],
    paddingClasses[padding],
    background,
    centerVertical && 'flex items-center',
    centerHorizontal && 'flex justify-center',
    centerVertical && centerHorizontal && 'flex items-center justify-center',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={baseClasses} style={style}>
      {children}
    </div>
  );
};
